import { render } from "./RoomSettings.vue?vue&type=template&id=3f5a79bd&scoped=true&ts=true"
import script from "./RoomSettings.vue?vue&type=script&lang=ts"
export * from "./RoomSettings.vue?vue&type=script&lang=ts"

import "./RoomSettings.vue?vue&type=style&index=0&id=3f5a79bd&lang=scss&scoped=true"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5a79bd"]])

export default __exports__